import ClassBreaksRenderer from '@arcgis/core/renderers/ClassBreaksRenderer';
import SimpleMarkerSymbol from '@arcgis/core/symbols/SimpleMarkerSymbol';
import Color from '@arcgis/core/Color';
import FeatureLayer from "@arcgis/core/layers/FeatureLayer";

import LabelClass from "@arcgis/core/layers/support/LabelClass";
import { getTextColor, roundOneDecimal } from 'src/store/common';
import PopupTemplate from '@arcgis/core/PopupTemplate';
import Graphic from '@arcgis/core/Graphic';
import Point from '@arcgis/core/geometry/Point';
import SpatialReference from '@arcgis/core/geometry/SpatialReference';
import moment from 'moment-timezone';

const popupTemplate = new PopupTemplate({
    title: "{id}",
    content: "<div id='custompoop' key='custompoop' class='custompoop' style='padding: 10px'>{name}</div>",

    outFields: ["{id}"],
    fieldInfos: [
        {fieldName: 'id', visible: false},
        {fieldName: 'name', visible: false},
        {fieldName: 'network', visible: false},
        {fieldName: 'state', visible: false},
    ]
});

export const returnValueNfdr = (value: any) => {
    if (value === null) {
        return -500000
    } else {
        return value;
    }
    
};

/* test feature layer this is where to test to see how to add a layer*/
export const formatNfdrDataToLayer = (data: any[], element: any, zoom: number, startDate: any, endDate: any, radio: any, fuelModel:string) => {
    const currentTime = moment().utc().toISOString();

    const missing = data.filter(item =>item[element.value] === null && item.nfdr_type==='O');
    const missing_forecast = data.filter(item =>item[element.value] === null && item.nfdr_type==='F');
    const obsQA_NFDR = data.filter(item => item.nfdr_type === 'O' && item[element.value] !== null && (item.quality_code===(0) || item.quality_code===null));
    const forecastsQA_NFDR = data.filter(item => item.nfdr_type === 'F'&& item[element.value] !== null && (item.quality_code===(0) || item.quality_code===null));
    const obsNotQA_NFDR = data.filter(item => item.nfdr_type === 'O' && item[element.value] !== null && (item.quality_code===(2) || item.quality_code===(1)));
    const forecastNotQA_NFDR = data.filter(item => item.nfdr_type === 'F' && item[element.value] !== null && (item.quality_code===(2) || item.quality_code===(1)));
    
    //qaflag true and obs not miss - square (obsNotQA_NFDR)
    //qaflag false and obs not miss - circle  (obsQA_NFDR)
    //obs missing - circle dots (missing)
    //forecast missing - circle dots (missing)
    //qaflag true and forecast not miss - triangle (forecastNotQA_NFDR)
    //qaflag false and forecast not miss - diamond (forcastsQA)
    /*below is a geojson layer for observations*/
    //"●●●"

    const allLayers = [
        {id: 'NFDR_Missing', data:missing, shape: 'circle', outlineColor: 'red', width: 2, sizeShape: "30px"},
        {id: 'Forecast_Missing_NFDR', data:missing_forecast, shape: 'diamond', outlineColor: 'red', width: 1, sizeShape: "30px"},
        {id: 'obsQA_NFDR', data:obsQA_NFDR, shape: 'circle', outlineColor: 'grey',width: 1, sizeShape: "30px"}, //obsQA_NFDR
        {id: 'obsNotQA_NFDR', data:obsNotQA_NFDR, shape: 'square', outlineColor: 'red', width: 2, sizeShape: "30px"},
        {id: 'forecastsQA_NFDR', data:forecastsQA_NFDR, shape: "diamond", outlineColor: 'grey',width: 1, sizeShape: "30px"},//forecastsQA_NFDR
        {id: 'forecastNotQA_NFDR', data:forecastNotQA_NFDR, shape: 'triangle', outlineColor: 'red',width: 2, sizeShape: '35px' },
    ];

    const checkElementTypeForLabel = (num:any, el: string)=>{
        if(num!==null){
            if(el==='gsi'){
                return (num)?.toString()
            }
            else{
                return roundOneDecimal(num)?.toString()
            }
        }
        else{
            return "●●●"
        }
    }

    const arrayToReturn = allLayers.map((layer:any)=>{
        const thisGraphic = layer.data?.map((item) =>
            new Graphic({
                geometry: new Point({
                    latitude: item.latitude,
                    longitude: item.longitude,
                    spatialReference: new SpatialReference({ wkid: 4326 })
                }),
                attributes: {
                    name: item.station_name,
                    id: item.station_id,
                    type: item.nfdr_type,
                    value: returnValueNfdr(item[element.value]),
                    label: checkElementTypeForLabel(item[element.value], element.value),
                    elevation: item.elevation,
                    network: item.network_name,
                    state: item.state,
                    has_historic_data: (item.has_historic_data).toString().toLowerCase()==='true'?1:0
                }

            })
        );

        const thisFeatureLayer = new FeatureLayer({
            source: thisGraphic,
            objectIdField: 'ObjectId',
            popupTemplate: popupTemplate,
            editingEnabled: true,
            id: `${layer.id}&Element=${radio}&Value=${element.value}&Zoom=${zoom}&StartDate=${startDate}&EndDate=${endDate}&fuelModel=${fuelModel}&currentTime=${currentTime}`,
            fields: [
                {
                    name: "ObjectId",
                    type: 'oid'
                },
                {
                    name: "value",
                    type: "double"
                },
                {
                    name: "name",
                    type: "string"
                },
                {
                    name: "id",
                    type: "integer"
                },
                {
                    name: "type",
                    type: "string"
                },
                {
                    name: "label",
                    type: "string"
                },
                {
                    name: "elevation",
                    type: "integer"
                },
                {
                    name: "network",
                    type: "string"
                },
                {
                    name: "state",
                    type: "string"
                },
                {
                name: "has_historic_data",
                type: "integer"
                },
            ],
            geometryType: "point",
            outFields: ["ObjectID", "name", "id", "state", "network", "has_historic_data"]
    
        });

        const thisRenderer = new ClassBreaksRenderer({
            field: "value",
            classBreakInfos: element.colors.map((color: any) => ({
                minValue: color.minValue,
                maxValue: color.maxValue,
                symbol: new SimpleMarkerSymbol({
                    style: layer.shape,
                    color: new Color(color.rgb),
                    size: layer.sizeShape,
                    outline: {
                        color: layer.outlineColor,
                        width: layer.width
                    }
                }),
                label: color.value
            }))
        });
        const thislabelingInfo = thisRenderer.classBreakInfos.map(classBreak => new LabelClass({
            labelExpressionInfo: { expression: "$feature.label" },
            symbol: {
                type: "text",
                color: getTextColor(classBreak.symbol.color),
                yoffset: layer.shape==='triangle'?-5:0,
                font: {
                    size: "10px",
                }
            },
            deconflictionStrategy: "none",
            labelPlacement: "center-center",
            where: `value >= ${classBreak.minValue} AND value <= ${classBreak.maxValue}`
        })
        );
    
        thisFeatureLayer.renderer = thisRenderer;
        thisFeatureLayer.labelsVisible = true;
        thisFeatureLayer.labelingInfo = thislabelingInfo;

        const name = layer.id;

        return {[name]: thisFeatureLayer }
    });

    const finalObj = Object.assign({}, ...arrayToReturn);
    return finalObj;

};